import { render, staticRenderFns } from "./AddUpdatePackageCategory.vue?vue&type=template&id=59258afa&scoped=true"
import script from "./AddUpdatePackageCategory.vue?vue&type=script&lang=js"
export * from "./AddUpdatePackageCategory.vue?vue&type=script&lang=js"
import style0 from "./AddUpdatePackageCategory.vue?vue&type=style&index=0&id=59258afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59258afa",
  null
  
)

export default component.exports